import { Breadcrumbs } from '@showroomjs/ui';
import * as React from 'react';
import { CodeFrameContextProvider } from '../lib/code-frame-context';
import { lazy } from '../lib/lazy';
const StandaloneEditor = lazy(() => import('./standalone-editor-lazy'));
export const MarkdownDocStandaloneEditor = (props) => {
    return (React.createElement(React.Fragment, null,
        React.createElement(Breadcrumbs, { items: [
                {
                    label: props.rootTitle,
                    url: '..',
                },
                {
                    label: 'Example',
                },
            ] }),
        React.createElement(CodeFrameContextProvider, { value: React.useMemo(() => ({
                showDeviceFrame: props.showDeviceFrame,
                frameDimensions: props.codeFrameDimensions,
            }), [props.showDeviceFrame, props.codeFrameDimensions]) },
            React.createElement(StandaloneEditor, null))));
};
//# sourceMappingURL=markdown-doc-standalone-editor.js.map